import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";
import { describe } from "./FindingCard";

export default function UndoDialog({ finding, onClose, onConfirm, busy }) {
  const approved = finding?.review?.status === "approved";
  return (
    <AlertDialog open={!!finding} onOpenChange={(v) => !v && !busy && onClose()}>
      <AlertDialogContent data-testid="undo-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{approved ? "Undo this correction?" : "Reopen this line for review?"}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-sm text-slate-600 space-y-1">
              <p className="font-medium text-slate-900">{finding?.description} · {finding?.invoice_number}</p>
              {approved ? (
                <p>The line goes back to its original extracted packaging <span className="font-medium text-slate-800">{describe(finding?.original)}</span> (currently {finding?.proposed_summary}) and returns to the review queue.</p>
              ) : (
                <p>The line keeps its packaging <span className="font-medium text-slate-800">{finding?.current_summary}</span> and simply returns to the review queue.</p>
              )}
              <p className="text-xs">Recorded in the history. Invoice image, quantities, prices, VAT and confirmed status are not affected.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="undo-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction disabled={busy} onClick={() => onConfirm(finding)} data-testid="undo-confirm">{approved ? "Undo correction" : "Reopen"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
